import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './styles.css'
import UpperNav from './../UpperNav'

/* logo */
import logo from '../../images/logo.svg'
import close from '../../images/icon-close.svg'
import menu from '../../images/icon-nav.svg'

export default function NavBar() {

  const [button, setButton] = useState(menu)
  const [navClassList, setNavClassList] = useState("")
  let navigate = useNavigate();

  function navOpen(){
    console.log("button clicked");
    if(navClassList === ""){
      setButton(close)
      setNavClassList("header__nav--open")
    }else if(navClassList === "header__nav--open"){
      setButton(menu)
      setNavClassList("")
    }
  }

  const handleLogo = ()=>{
    navigate("/")
  }

  return (
    <>
    <div>
      <UpperNav modularClass="uppernav--top" />
      <header className="user__header">
        <div className="header__logo" onClick={handleLogo}>
            <img src={logo} alt="AB hires"/>
            <h1>AB hires</h1>
        </div>
        <img src={button} alt="menu buttom" className="btn-menu" onClick={()=>navOpen()}/>
        <nav className={`header__nav ${navClassList}`}>
          <ul className="header__navlist">
            <li className="header__navitem"><Link to="/">Home</Link></li>
            <li className="header__navitem"><Link to="/Services">Services</Link></li>
            <li className="header__navitem"><Link to="/Jobs">Jobs</Link></li>
            <li className="header__navitem"><Link to="/Faqs/">FAQ's</Link></li>
            <li className="header__navitem"><Link to="/ContactUs">Contact us</Link></li>
          </ul>
        </nav>
      </header>
    </div>
    </>
  );
}
